module.exports = __webpack_public_path__ + "src/img/index_menu/2.png?6118e4e0e88fb45f331aea219f33ad8a";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/2.png
// module id = 175
// module chunks = 0